import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function StockTransferReceipt_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/StockTransferReceipt" ? (
        <div>
          <span className="breadcrumb-not-active ">StockTransferReceipt </span>
        </div>
      ) : vPathName === "/StockTransferReceiptDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/StockTransferReceipt"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            StockTransferReceipt
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">
              StockTransferReceiptDetail{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default StockTransferReceipt_BreadCrumbs;
